// Material Kit 2 React pages
import Venture from "presentation/components/VenturePage";

export default function VenturePage() {
  return <Venture />;
}